import React, { FC } from 'react'
import { FooterSocialPropsType } from '../Footer.types'
import { APIENDPOINT, getCWPEnvironmentForURL } from '../../../../common/utils/common-utils'
import './footer-social.scss'

export const FooterSocial: FC<FooterSocialPropsType> = props => {
  const {
    searchApplyLabel,
    searchApplyUrl,
    linkedinLink,
    youtubeLink,
    facebookLink,
    instagramLink,
  } = props
  const env = getCWPEnvironmentForURL(window.location.href)
  const iconBasePath = `${
    APIENDPOINT(env).baseGallery
  }/content/gallery/ampmicrosites/brand-icons/icon-sprite.svg`
  return (
    <div className='FooterSocial u-bgColorBrand u-paddingVert5gu'>
      <div className='FooterSocial--container u-posRelative u-sizeConstrained u-flex u-flexJustifyBetween u-flexAlignItemsCenter'>
        <a
          title='amp-logo'
          className='social-logo u-posRelative u-sm-hidden'
          data-tracking='Link'
          href='/'
          data-analytics='Ameriprise'>
          <svg
            className='BrandIcon'
            fill='#fff'
            aria-hidden='true'
            preserveAspectRatio='xMinYMin meet'>
            <use href={`${iconBasePath}#ampf-compass`} />
          </svg>
        </a>
        <div className='FooterSocial--socialContainer u-flex u-flexAlignItemsCenter u-flexJustifyStart u-sm-flexJustifyCenter u-sm-sizeFull u-sm-flexWrap'>
          <a
            className='Button Button--primary Button--reversed u-marginRight2gu u-sm-marginRight0 u-sm-sizeFull'
            data-tracking='Link'
            data-analytics={searchApplyLabel}
            href={searchApplyUrl}
            rel='noreferrer'
            target='_blank'>
            {searchApplyLabel}
          </a>
          <a
            title='Go to Ameriprise LinkedIn'
            className='social-logo'
            href={linkedinLink}
            rel='noreferrer'
            target='_blank'
            data-analytics='Linkedin'>
            <svg aria-hidden='true'>
              <use href={`${iconBasePath}#social-linkedin-white`} />
            </svg>
          </a>
          <a
            title='Go to Ameriprise Facebook'
            className='social-logo'
            href={facebookLink}
            rel='noreferrer'
            target='_blank'
            data-analytics='Facebook'>
            <svg aria-hidden='true'>
              <use href={`${iconBasePath}#social-facebook-white`} />
            </svg>
          </a>
          <a
            title='Go to Ameriprise YouTube'
            className='social-logo'
            href={youtubeLink}
            rel='noreferrer'
            target='_blank'
            data-analytics='Youtube'>
            <svg aria-hidden='true'>
              <use href={`${iconBasePath}#social-youtube-white`} />
            </svg>
          </a>
          <a
            title='Go to Ameriprise Instagram'
            className='social-logo'
            href={instagramLink}
            rel='noreferrer'
            target='_blank'
            data-analytics='Instagram'>
            <svg className='u-fillColorWhite' aria-hidden='true'>
              <use href={`${iconBasePath}#social-instagram`} />
            </svg>
          </a>
        </div>
      </div>
    </div>
  )
}
